export var AuthStatus;
(function (AuthStatus) {
    AuthStatus["PENDING"] = "pending";
    AuthStatus["AUTHORIZED"] = "authorized";
})(AuthStatus || (AuthStatus = {}));
